/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (page, sortAttr, label, filter_tags, search) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  if (filter_tags && filter_tags.length > 0) {
    filter_tags.forEach(tag => {
      params += `&filter_tags[]=${tag}`;
    });
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '', filter_tags=[]) {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      filter_tags,
      ''
    )}`;
    return axios.get(requestURL);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '', filter_tags=[]) {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      filter_tags,
      search
    )}`;
    return axios.get(requestURL);
  }

  importContacts(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  importLeads(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/process_leads`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response
  }
  applyLabels(selectedAudience,accountId) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/labeled_contacts`, { audiance: selectedAudience, account_id: accountId}, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }

  labeledOneOffContacts (selectedAudience,accountId) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/labeled_one_off_contacts`, { audiance: selectedAudience, account_id: accountId}, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  labeledEmailContacts (selectedAudience,accountId) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/labeled_email_contacts`, { audiance: selectedAudience, account_id: accountId}, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  createLeadsContact(leadsObj) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/create_leads_contacts`, leadsObj, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  get_stats(id) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/get_stats`, id, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  get_records(id) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/get_records`, id, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  get_email_records(id) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/get_email_records`, id, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  play_campaign(id) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/play_campaign`, id, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  pause_campaign(id) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/pause_campaign`, id, {
      headers: { 'Content-Type': 'application/json' },
    });
     return response
  }
  createRecordStats(leadsObj){
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/create_record_stats`, leadsObj, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response
  }
  createEmailRecordStats(leadsObj){
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/create_email_record_stats`, leadsObj, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response
  }
  getLeadsContact(leadsObj) {
    let leadsUrl = this.url.split("/api")[0];
    const response = axios.post(`${leadsUrl}/webhooks/get_leads_contacts`, leadsObj, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response
  }
    exportContacts() {
        return axios.get(`${this.url}/export_contacts`);
    }

    getContactLabel(contact_id) {
        return axios.get(`${this.url}/contact_label/${contact_id}.json`);
    }

    fetchTransactionHistories(contactId) {
        return axios.get(`${this.url}/fetch_transaction_histories.json?q=${contactId}`);
    }

    fetchEvent(id) {
        return axios.get(`/app/event/${id}/details.json`);
    }

    getContactMeetings(id) {
        return axios.get(`${this.url}/schedule_list.json?q=${id}`)
    }

    getNameByPhoneNumber(phoneNumber) {
        return axios.get(`${this.url}/get_name_by_phone_number`, {
            params: {
                phone_number: phoneNumber
            }
        })
    }
}

export default new ContactAPI();
